<script setup>
import {reactive,onMounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";

const compName = 'DisbursementsComponent';

const props = defineProps({
  contextSchemaA: String,
  contextSchemaB: String,
  contextIdA: String,
  contextIdB: String
});

const data = reactive({
  search: null,
  dataLoading: true,
  newDisb: false,
  headers: [
    { title: 'Claim', key: 'claimnumber' },
    { title: 'Client', key: 'client' },
    //{ title: 'Invoice', key: 'invoice' },
    { title: 'Amount', key: 'amount' },
    { title: 'Date', key: 'date' },
    { title: '', key: 'action' },

  ],
  items: [],
  newItem: {
    amount: null,
    invoiceId: null,
    claimId: null,
    clientId: null,
  },
});

const submitHoldback = (item) => {
  let contextIdA = props.contextIdA;
  
  let contextIdB = props.contextIdB;
  
  ApiWrapper.post('disbursements', 'new-holdback', {dId: item.disbid, ppId: contextIdA, amount: item.newHbAmount, pId: contextIdB})
      .then((response) => {
        activeComponentStore.notifyComponents(['holdback'],compName);
        ToastUtil.successMsg('Created holdback');
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
}

const getData = () => {
  let contextIdA = props.contextIdA;
  let contextIdB = props.contextIdB;
  if (contextIdA === null || contextIdB === null) {
    ApiWrapper.get('disbursements', 'disbursements')
        .then((response) => {
          if(response.disbursements){
            data.items = response.disbursements;
          }
        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
        .finally(()=>{
          data.dataLoading = false
        })
  } else {
    ApiWrapper.get(
            'disbursements',
            'pay-period-person','payPeriodId=' +
            contextIdA +
            '&personId=' +
            contextIdB
        )
        .then((response) => {
          if(response.payments){
            data.items = response.payments;
          }
        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
        .finally(()=>{
          data.dataLoading = false
        })
  }
}

const saveItem = () => {
  ApiWrapper.post('disbursements', 'create', {
        newDisbursement: data.newItem,
        payPeriodId: props.contextIdA,
        personId: props.contextIdB
      })
      .then((response) => {
        getData()
        discardItem()
        ToastUtil.successMsg('Created disbursement');
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.dataLoading = false;
      })
}

const bumpItemFromPayPeriod = (item) => {
  data.dataLoading = true;
  ApiWrapper.post('disbursements', 'bump-from-pay-period', {payPeriodId: props.contextIdA, disbursementId: item.disbid})
      .then((response) => {
        activeComponentStore.notifyComponents(['holdback'],compName);
        ToastUtil.successMsg('Bumped disbursement of '+item.amount+' from Pay Period');
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.dataLoading = false
        getData();
      })
}

const discardItem = () => {
  data.newItem.amount = null
  data.newItem.invoiceId = null
  data.newItem.claimId = null
  data.newItem.clientId = null
  data.newDisb = false
}

onMounted(()=>{
  getData()
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar density="compact" flat color="white">
        <v-toolbar-title>Disbursements</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-row>
        <v-col cols="6">
          <v-text-field density="compact" v-model="data.search" append-icon="mdi-magnify" label="Search" single-line hide-details
                        class="ml-4"></v-text-field>
        </v-col>
      </v-row>
      <v-data-table density="compact" :items="data.items" :headers="data.headers" :search="data.search" :loading="data.dataLoading"
                    loading-text="Loading... Please wait">
        <template v-slot:[`item.amount`]="{ item }">
          <span>{{ item.amount }}</span>
        </template>
        <template v-slot:[`item.client`]="{ item }">
          <RouterLink :to="`/client/${item.clientid}`">
            {{ item.client }}
          </RouterLink>
        </template>
        <template v-slot:[`item.claimnumber`]="{ item }">
          <RouterLink :to="`/claim/${item.claimid}`">
            {{ item.claimnumber }}
          </RouterLink>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-row>
            <v-col cols="6">
              <v-btn size="small" color="primary" v-if="item.newHb !== true">
                <v-tooltip
                    activator="parent"
                    location="bottom"
                >Click to create Holdback</v-tooltip>
                <v-icon v-if="item.newHb !== true && Permissions.checkPermissions(['holdbacks.create'])" class="mr-2" @click="item.newHb = true; data.search = 'a'; data.search = '';">mdi-alpha-h-box-outline</v-icon>
              </v-btn>
              <v-text-field v-if="item.newHb" type="number" v-model="item.newHbAmount" label="Holdback Amount"></v-text-field>
              <v-btn
                  size="small"
                  variant="elevated"
                  v-if="item.newHb"
                  color="error"
                  class="white--text mr-2"
                  @click="item.newHb = false; data.search = ' '; search = null"
              >Cancel</v-btn>
              <v-btn
                  v-if="item.newHb"
                  size="small"
                  variant="elevated"
                  color="primary"
                  class="white--text"
                  @click="submitHoldback(item); item.newHb = false; data.search = ' '; search = null"
              >Submit</v-btn>
            </v-col>
            <v-col cols="6" v-if="Number(item.amount)<0 && item.newHb !== true && Permissions.checkPermissions(['holdbacks.bump-from-pay-period'])">
              <v-btn size="small" color="warning" @click="bumpItemFromPayPeriod(item)">
                <v-tooltip
                    activator="parent"
                    location="bottom"
                >Click to bump this negative balance off of the Pay Period</v-tooltip>
                <v-icon>mdi-currency-usd-off</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="6" v-else></v-col>
          </v-row>

        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}

.v-list-item-subtitle {
  font-size: 10px !important;
  color:black;
}

.v-toolbar-subtitle {
  color:black !important;
}
</style>